import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ApplicationStatusCard = ({ application }) => {
  const navigate = useNavigate();

  const getStatusConfig = (status) => {
    const configs = {
      'Applied': { color: 'text-secondary', bg: 'bg-secondary/10', icon: 'FileText' },
      'Under Review': { color: 'text-warning', bg: 'bg-warning/10', icon: 'Eye' },
      'Shortlisted': { color: 'text-success', bg: 'bg-success/10', icon: 'CheckCircle' },
      'Interview Scheduled': { color: 'text-primary', bg: 'bg-primary/10', icon: 'Calendar' },
      'Rejected': { color: 'text-error', bg: 'bg-error/10', icon: 'XCircle' }
    };
    return configs?.[status] || configs?.['Applied'];
  };

  const statusConfig = getStatusConfig(application?.status);

  const handleClick = () => {
    navigate('/application-tracking');
  };

  return (
    <div 
      onClick={handleClick}
      className="bg-card border border-border rounded-lg p-4 hover:shadow-card transition-smooth cursor-pointer"
    >
      <div className="flex items-start gap-3">
        <div className="w-12 h-12 rounded-lg overflow-hidden flex-shrink-0 bg-muted">
          <Image 
            src={application?.companyLogo} 
            alt={application?.companyLogoAlt}
            className="w-full h-full object-cover"
          />
        </div>

        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-semibold text-foreground truncate mb-1">
            {application?.jobTitle}
          </h4>
          <p className="text-xs text-muted-foreground truncate mb-2">{application?.company}</p>

          <div className={`inline-flex items-center gap-1.5 px-2 py-1 rounded ${statusConfig?.bg} ${statusConfig?.color} text-xs font-medium`}>
            <Icon name={statusConfig?.icon} size={14} />
            <span>{application?.status}</span>
          </div>

          <div className="flex items-center gap-2 mt-2 text-xs text-muted-foreground">
            <Icon name="Clock" size={12} />
            <span>Applied {application?.appliedDate}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationStatusCard;